<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="$route.fullPath"></router-view>
    <audio src="/assets/tip.mp3" id="audioTip" autoplay="false"></audio>
  </div>
</template>
<script>
import jsBridge from 'ym-jsbridge'
export default {
  mounted() {
    const that = this;
    var getNotify = function () {
      if (localStorage.getItem("token")) {
        that.netCall("/Appapi/Index/notify", {}, function (data) {
          if (data.status == 1) {
            if (data.data.newChatNum > 0) {
              that.$store.commit('updateChatNum', data.data.newChatNum > 99 ? "99+" : data.data.newChatNum);
            } else {
              that.$store.commit('updateChatNum', '0');
            }
            if (data.data.newFriendship > 0) {
              that.$store.commit('updateFriendship', data.data.newFriendship > 99 ? "99+" : data.data.newFriendship);
            } else {
              that.$store.commit('updateFriendship', '0');
            }
          }
        });
      }
    };
    getNotify();
    setInterval(function () {
      getNotify();
    }, 3000);

    var pWebsocket = null;
    var lastPTime = new Date().getTime();
    var pGroupSoundWav = '/assets/new.wav';
    var pPrivateSoundWav = '/assets/private.mp3';
    var newPSocket = function() {
      if (localStorage.getItem("token")) {
        //判断当前浏览器是否支持WebSocket
        if ('WebSocket' in window) {
          pWebsocket = new ReconnectingWebSocket(websocketUrl);
        } else {
          alert('当前浏览器不支持websocket');
        }

        //连接成功建立的回调方法
        pWebsocket.onopen = function () {
          lastPTime = new Date().getTime();
          console.log('pWebSocket连接成功');
        };

        //连接发生错误的回调方法
        pWebsocket.onerror = function () {
          console.log('pWebSocket连接发生错误');
        };

        //接收到消息的回调方法
        var pGroupSound = new Howl({
          src: [pGroupSoundWav]
        });
        var pPrivateSound = new Howl({
          src: [pPrivateSoundWav]
        });
        pWebsocket.onmessage = function (event) {
          lastPTime = new Date().getTime();
          var data = JSON.parse(event.data);
          var type = data.type || '';
          if (type == 'init') {
            that.netCall("/Api/message/bind", {client_id: data.client_id, in_app: 1}, function (res) {
              console.log(res);
            });
          } else if (type == 'ping') {
            console.log('ping');
          } else if (type == "dial") {
            if (data.call == 1) {
              window.location.href = "/#/chat/video?initiate=0&id=" + data.another_id;
            } else if (data.call == 2) {
              window.location.href = "/#/chat/audio?initiate=0&id=" + data.another_id;
            }
          } else {
            if (data.position == "private") {
              pPrivateSound.play();
            } else {
              pGroupSound.play();
            }
            if (navigator.vibrate) {
              navigator.vibrate(2000);
            } else if (navigator.webkitVibrate) {
              navigator.webkitVibrate(2000);
            }
            if (data.newChatNum > 0) {
              that.$store.commit('updateChatNum', data.newChatNum > 99 ? "99+" : data.newChatNum);
              // 设置角标
              // if (jsBridge.inApp) {
              //   jsBridge.notification.setBadge(data.newChatNum);
              // }
            } else {
              that.$store.commit('updateChatNum', '0');
              // 设置为 0 则清除角标
              // if (jsBridge.inApp) {
              //   jsBridge.notification.setBadge(0);
              // }
            }

            // if (jsBridge.inApp) {
            //   jsBridge.notification.requestAuth(function (granted) {
            //     if (granted) {
            //       jsBridge.notification.notify({
            //         title: data.data[0].nickname,
            //         content: data.data[0].content,
            //         url: data.data[0].url,
            //         openUrlInApp: true,
            //       }, function (succ, data) {
            //         if (!succ) {
            //           alert(JSON.stringify(data));
            //         }
            //       });
            //     } else {
            //       jsBridge.appSettings();
            //     }
            //   });
            // }
          }
        };
      }
    }

    newPSocket();
    setInterval(function() {
      var time = new Date().getTime();
      if(time - lastPTime > 10000) {
        lastPTime = time;
        newPSocket();
      }
    }, 3000);

    /** 极光推送 */
    // if (jsBridge.inApp) {
    //   if (!localStorage.getItem("jiguangDeviceId")) {
    //     jsBridge.jiguang.getRegistrationID(function (rid) {
    //       localStorage.setItem("jiguangDeviceId", rid);
    //     });
    //   }
    //   /** 用户按主屏HOME键，有电话拨入等， App被推到后台时触发。*/
    //   jsBridge.onAppEnterBackground(function(){
    //     let device_id = localStorage.getItem("jiguangDeviceId");
    //     that.netCall("/Appapi/Index/foreground", {in_foreground: 0, device_id: device_id ? device_id : ''}, function (data) {});
    //   });
    //   /** 当App被激活，回到前台时触发。*/
    //   jsBridge.onAppEnterForeground(function(){
    //     let device_id = localStorage.getItem("jiguangDeviceId");
    //     that.netCall("/Appapi/Index/foreground", {in_foreground: 1, device_id: device_id ? device_id : ''}, function (data) {});
    //   });
    //   jsBridge.jiguang.setListener(function (msg) {
    //     if (msg.extra != '') {
    //       var extra = JSON.parse(msg.extra);
    //       if (extra.newChatNum > 0) {
    //         jsBridge.jiguang.setBadge(extra.newChatNum);
    //       }
    //     }
    //   });
    // }
  },
};
</script>